import { useFormContext } from 'react-hook-form';
import { Trans, useTranslation } from 'react-i18next';
import { Anchor, ButtonSubmit, Form } from '@anytag/shared-atoms';
import { PasswordField, TextField } from '@anytag/shared-molecules';
import { SignInFormKeys, SignInFormValues } from '../../SignIn/SignInForm/types';

export const Template = () => {
  const { t } = useTranslation();
  const {
    formState: { isSubmitting }
  } = useFormContext<SignInFormValues>();

  return (
    <Form.Body className="px-0 py-12">
      <div className="mx-auto my-0 w-107 px-10">
        <TextField<SignInFormKeys> name="email" title={t('TextForm.Email')} placeholder="your@email.com" />
        <PasswordField<SignInFormKeys> name="password" title={t('Password.Your Password')} required />

        <ButtonSubmit variant="solid" loading={isSubmitting} title={t('Button.Sign In')} className="mt-6 w-full" />
      </div>

      <p className="mt-8 text-center text-[11px] leading-[140%] text-tertiary">
        <Trans
          i18nKey="SignInConfirmation"
          components={{
            a1: <Anchor variant="blue" css={{ display: 'inline', lineHeight: 'inherit' }} to="/privacy" />,
            a2: <Anchor variant="blue" css={{ display: 'inline', lineHeight: 'inherit' }} to="/terms" />
          }}
        />
      </p>
    </Form.Body>
  );
};
